import axios from "axios";

export default {
  state: () => ({
    data: null,
    loadingData: false,
    errorLoadingData: false,
    appSections: [],
    serviceOptions: []
  }),
  mutations: {
    fetchedData(state, currentUser) {
      state.data = currentUser;
    },
    loadingData(state, loadingFlag) {
      state.loadingData = loadingFlag;
    },
    errorLoadingData(state, errorFlag) {
      state.errorLoadingData = errorFlag;
    },
    setServiceOptionState: (state, serviceOptions) => state.serviceOptions = serviceOptions,
  },
  getters: {
    data: (state) => state.data,
    loadingData: (state) => state.loadingData,
    errorLoadingData: (state) => state.errorLoadingData,
    serviceOptions: (state) => state.serviceOptions,
  },
  actions: {
    async getCurrentUser({ commit }) {
      const url = "/apis/suite-api/api/v1/user-info";
      commit("loadingData", true);
      try {
        const response = await axios.get(url);
        commit("loadingData", false);
        if (response.status === 200) {
          commit("fetchedData", response.data);
        } else {
          commit("fetchedData", null);
          commit("errorLoadingData", true);
        }
      } catch (err) {
        commit("loadingData", false);
        commit("fetchedData", null);
        commit("errorLoadingData", true);
      }
    },
  },
};
